import { render } from "./ProductsIndexPage.vue?vue&type=template&id=d3c9c4c0&scoped=true"
import script from "./ProductsIndexPage.vue?vue&type=script&lang=js"
export * from "./ProductsIndexPage.vue?vue&type=script&lang=js"

import "./ProductsIndexPage.vue?vue&type=style&index=0&id=d3c9c4c0&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3c9c4c0"]])

export default __exports__